// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__apMwO","outlined":"button_outlined__DeFth","solid":"button_solid__Rn4pm"};